import { render, staticRenderFns } from "./HistoryBewertungen.vue?vue&type=template&id=583baba0&"
import script from "./HistoryBewertungen.vue?vue&type=script&lang=js&"
export * from "./HistoryBewertungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports